// extracted by mini-css-extract-plugin
module.exports = {"form":"NewListForm_form__Ol20Q","inputField":"NewListForm_inputField__Ymwis","formField":"NewListForm_formField__ZrqMU","buttonContainer":"NewListForm_buttonContainer__z6Xht"};